import { useLocation } from 'react-router-dom-v5-compat'

export const useFakeData = (): boolean => {
  const location = useLocation()

  return new URLSearchParams(location.search).get('fake_data') === 'true'
}
